<template id="NombrePageCourante">
    <div class="pagecourante">
        <p aria-live="polite" v-if="nbrPages==1">Éléments {{pageCourante}} à {{pageCourante * nbrResultatsDernierePage}}</p>
        <p aria-live="polite" v-else-if="nbrPages > 1">Éléments {{pageCourante == 1 ? pageCourante : ((pageCourante - 1) * nbrResultats) + 1}} à {{pageCourante != nbrPages ? pageCourante * nbrResultats : ((pageCourante - 1) * nbrResultats) + nbrResultatsDernierePage}}</p>

    </div>
</template>

<script>
    export default{
        name:"NombrePageCourante",
        components: {
    
        },
        props: {
            pageCourante: {
                type: Number
	        },
            nbrPages: {
                type: Number
            },
            nbrResultats: {
                type: Number
            },
            nbrResultatsDernierePage: {
                type: Number
            }
        },
        data(){
          return{
              
          }
        }, 
        methods:{
          
        },
        computed: {
    
        }
    }
</script>